// 导出该模块state、actions、mutations
import { extend } from 'sk-ui/lib/utils/util.js'

import software from '../../softwareMng/metaData/software'
import actions from '../actions'
const softwareCopy = extend(true, {}, software)
softwareCopy.toolbar.items = []
delete softwareCopy.view.menus[1]
export default {
  state: softwareCopy,
  actions
}
